import React from "react";
import PropTypes from "prop-types";
import "./PageBackground.scss";

/**
 * Renders a page background along with other page content.
 * @param {String} bgImage - The background image to render.
 * @param {ReactChildren} children - Other page content.
 */
const PageBackground = ({ bgImage, children, className }) => {
  return (
    <div
      className={`main-page ${className ? className : ""}`}
      style={{ backgroundImage: bgImage ? `url(${bgImage})` : "" }}
    >
      {children}
    </div>
  );
};

PageBackground.propTypes = {
  bgImage: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default PageBackground;
